<div *ngIf="isOpen" class="vf-acm-overlay"
    (click)="$event.target === $event.currentTarget && close()">
    <div class="vf-acm-card">

        <!-- ─── SCREEN 1: Almost there! ─── -->
        <ng-container *ngIf="!showEmailTemplate">
            <button type="button"
                class="vf-acm-close-btn d-flex h-32 w-32 text-gray-600 hover:text-red-600 hover:bg-red-50 border-2 border-gray-300 hover:border-red-500 transition-all rounded-8 bg-background justify-content-center"
                (click)="close()" aria-label="Close">
                <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
            </button>
            <div class="vf-acm-header-strip">
                <div class="vf-acm-ms-logo">
                    <svg width="28" height="28" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1"  y="1"  width="10" height="10" fill="#f25022"/>
                        <rect x="12" y="1"  width="10" height="10" fill="#7fba00"/>
                        <rect x="1"  y="12" width="10" height="10" fill="#00a4ef"/>
                        <rect x="12" y="12" width="10" height="10" fill="#ffb900"/>
                    </svg>
                </div>
                <div>
                    <div class="vf-acm-title">Almost there!</div>
                    <div class="vf-acm-subtitle">One quick step to connect your Microsoft 365 account</div>
                </div>
            </div>

            <div class="vf-acm-body">
                <p class="vf-acm-desc">
                    Your Microsoft 365 admin just needs to enable Trovve — we've got a ready-to-send request to make it quick.
                </p>

                <div class="vf-acm-hiw-box">
                    <div class="vf-acm-hiw-label">HOW IT WORKS</div>

                    <div class="vf-acm-step">
                        <div class="vf-acm-step-icon vf-acm-icon-orange">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/></svg>
                        </div>
                        <div>
                            <div class="vf-acm-step-name">Send a request to your admin</div>
                            <div class="vf-acm-step-note">Takes less than 30 seconds</div>
                        </div>
                    </div>
                    <div class="vf-acm-step-line"></div>

                    <div class="vf-acm-step">
                        <div class="vf-acm-step-icon vf-acm-icon-blue">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        </div>
                        <div>
                            <div class="vf-acm-step-name">Your admin reviews and approves</div>
                            <div class="vf-acm-step-note">Usually 1–2 clicks on their end</div>
                        </div>
                    </div>
                    <div class="vf-acm-step-line"></div>

                    <div class="vf-acm-step">
                        <div class="vf-acm-step-icon vf-acm-icon-green">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>
                        </div>
                        <div>
                            <div class="vf-acm-step-name">Come back and connect — you're all set!</div>
                            <div class="vf-acm-step-note">Works for your whole team after this</div>
                        </div>
                    </div>
                </div>

                <button class="vf-acm-btn-primary" (click)="showEmailTemplate = true">Request admin approval</button>
                <button class="vf-acm-btn-secondary" (click)="openAdminConsentUrl()" style="margin-top:8px;">I'm an admin — Approve now</button>

                <div class="vf-acm-faq-row" (click)="adminConsentFaqOpen = !adminConsentFaqOpen">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9 9a3 3 0 0 1 6 0c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12" y2="17" stroke-linecap="round" stroke-width="3"/></svg>
                    <span>Why do I need admin approval?</span>
                    <svg class="vf-acm-chevron" [class.vf-acm-chevron-open]="adminConsentFaqOpen" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
                </div>
                <div class="vf-acm-faq-content" *ngIf="adminConsentFaqOpen">
                    Microsoft requires that an organization admin reviews and approves any app that accesses Microsoft 365 data like calendars, files, and Teams.
                    <br><br>
                    Trovve needs these permissions to sync your tasks, meetings, and documents. Once your admin approves, every team member can connect instantly — no one else has to go through this step.
                </div>
            </div>
        </ng-container>

        <!-- ─── SCREEN 2: Send email to admin ─── -->
        <ng-container *ngIf="showEmailTemplate">
            <div class="vf-acm-nav-row justify-content-between">
                <button class="vf-acm-back-btn" (click)="showEmailTemplate = false">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
                    Back
                </button>
                <button type="button"
                    class="d-flex h-32 w-32 text-gray-600 hover:text-red-600 hover:bg-red-50 border-2 border-gray-300 hover:border-red-500 transition-all rounded-8 bg-background justify-content-center"
                    (click)="close()" aria-label="Close">
                    <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
                </button>
            </div>

            <div class="vf-acm-header-strip mt-n2">
                <div class="vf-acm-email-icon-wrap">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                </div>
                <div>
                    <div class="vf-acm-title">Send a request to your admin</div>
                    <div class="vf-acm-subtitle">Copy the message below</div>
                </div>
            </div>

            <div class="vf-acm-body">
                <div class="vf-acm-email-box">
                    <div class="vf-acm-email-box-label">
                        <span class="vf-acm-dot-amber"></span> Ready-to-send message
                    </div>
                    <div class="vf-acm-email-body-text">{{ adminConsentEmailBody }}</div>
                </div>

                <a class="vf-acm-btn-primary" style="cursor:pointer" (click)="copyAdminConsentEmailText()">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:8px"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                    Copy text to send via Teams or Email
                </a>

                <div class="vf-acm-info-strip">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#22c55e" style="flex-shrink:0;margin-top:1px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
                    <span>You'll get an email once approved — most admins respond within a few hours.</span>
                </div>

                <div class="vf-acm-find-admin">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M9 9a3 3 0 0 1 6 0c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12" y2="17" stroke-linecap="round" stroke-width="3"/></svg>
                    <a href="https://support.microsoft.com/en-us/office/how-do-i-find-my-microsoft-365-admin-59b8e361-dbb6-407f-8ac3-a30889e7b99b" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                        How do I find my Microsoft 365 admin?
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-left:3px"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                    </a>
                </div>
            </div>
        </ng-container>

    </div>
</div>
